/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ForTactical: cross out sizes that are sold out in every colour (v1, 2026-10-31).
// On products with two options (Size + Color), Venue removes the sold-out mark
// from the first option. This puts the mark back on a first-option value when no
// variant with that value is available. Colour marks are left to the theme.
(() => {
  const PICKERS = 'variant-radios, variant-mixed-inputs';

  const fix = (picker) => {
    const json = picker.querySelector('script[id^="all-variant-data-"]');
    if (!json) return;
    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;
    const groups = picker.querySelectorAll('fieldset, select');
    if (groups.length < 2 || groups[0].tagName !== 'FIELDSET') return;
    groups[0].querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = input.nextElementSibling;
      if (!label) return;
      const soldOut = !variants.some((v) => v.available && v.options && v.options[0] === input.value);
      if (label.classList.contains('is-disabled') !== soldOut) {
        label.classList.toggle('is-disabled', soldOut);
      }
    });
  };

  const watch = (picker) => {
    if (picker.ftxSoldOutWatched) return;
    picker.ftxSoldOutWatched = true;
    fix(picker);
    new MutationObserver(() => fix(picker)).observe(picker, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  let queued = false;
  const scan = () => {
    queued = false;
    document.querySelectorAll(PICKERS).forEach(watch);
  };

  scan();
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }).observe(document.body, { childList: true, subtree: true });
})();
